import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const suelo = createAsyncThunk(
    'suelo/getSuelo',
    async () => {
        try {
            const request = await axios.get("/api/sensor/getSuelo")
            return request.data
        } catch (error) {
            throw error
        }
    }
)



